import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import "../../assets/css/bootstrap.css";
import "../../assets/css/fontawesome-all.css";
import "../../assets/css/style.css";
import "../../assets/css/custompg.css";
import "../../assets/css/responsive.css";
import { useNavigate, useLocation } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [show, setShow] = useState(false);

  const isLoginPage = location.pathname === "/login";
  const isAddBusiness = isLoginPage && location.state?.fromAddBusiness;
  const isLoginActive = isLoginPage && !isAddBusiness;

  return (
    <header>
      <div className="container-fluid">
        <div className="tophead">
          <div className="logo">
            <a href="/">
              <img
                src={require("../../assets/images/logo.png")}
                alt="Logo"
                style={{ marginRight: "10px" }}
              />
              <strong style={{ color: "white" }}>TrustApp</strong>
            </a>
          </div>
          <div className="searchdiv">
            <input
              type="text"
              placeholder="Search for more than 400 services"
            />
            <button className="fas fa-search"></button>
          </div>
          <div className="otherlink">
            <ul>
              <li>
                <Button className={isLoginActive ? "addbusinessbtn" : "loginbtn"} onClick={() => navigate("/login")}>
                  Login
                </Button>
              </li>
               <li>
                 <a
                   className={(!isLoginPage || isAddBusiness) ? "addbusinessbtn" : "loginbtn"}
                   onClick={() => navigate("/login", { state: { fromAddBusiness: true } })} // MODIFIED
                 > Add Business
                 </a>
               </li>
              <li>
                <a href="#">More</a>
                <ul className="submenu">
                  <li>
                    <a href="#" style={{ color: "#94a3b8", cursor: "not-allowed" }}>
                      <i className="fas fa-bell"></i> Notification Preferences
                    </a>
                  </li>
                  <li>
                    <a
                      style={{ cursor: "pointer" }}
                      onClick={() => navigate("/HelpCenter")}
                    >
                      <i className="fas fa-cog"></i> Support & Setting
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.youtube.com/playlist?list=PLGPpgDt6rdY99nCCp3eSSMCpYtSS7ZiwE"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube"></i> Trust Youtube Channel
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://play.google.com/store/apps/details?id=com.trustapp"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fas fa-download"></i> Download App
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div className="mob_menu">
          <div className="logo">
            <i
              className="far fa-bars menubar"
              onClick={() => setShow((s) => !s)}
            ></i>
            <div>
              <a href="/">
                <img
                  src={require("../../assets/images/logo.png")}
                  alt="Logo"
                  style={{ marginRight: "10px" }}
                />
              </a>
              <strong style={{ color: "white" }}>TrustApp</strong>
            </div>
            <Button className={isLoginActive ? "addbusinessbtn" : "loginbtn"} onClick={() => navigate("/login")}>
              Login
            </Button>
          </div>
          <div className="searchdiv">
            <input
              type="text"
              placeholder="Search for products, brands and more"
            />
            <button className="fas fa-search"></button>
          </div>
          <div>
            <div
              className="otherlink"
              style={{ display: show ? "block" : "none" }}
            >
              <div className="sidelogo">
                <a href="#">
                  <img
                    src={require("../../assets/images/logo.png")}
                    alt=""
                    style={{ maxWidth: "30px" }}
                  />
                </a>
                <i
                  className="fas fa-times closebtn"
                  onClick={() => setShow((s) => !s)}
                ></i>
              </div>
               <ul>
                 <li>
                   <a className="addbusinessbtn" style={{ cursor: "pointer" }} onClick={() => navigate("/login", { state: { fromAddBusiness: true } })}> {/* MODIFIED */}
                     Add Business

                   </a>
                 </li>
                <li>
                  <a href="#" style={{ color: "#94a3b8", cursor: "not-allowed", display: "flex", alignItems: "center", gap: "8px" }}>
                    <i className="fas fa-bell"></i> Notification Preferences
                  </a>
                </li>
                <li>
                  <a
                    style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "8px" }}
                    onClick={() => navigate("/HelpCenter")}
                  >
                    <i className="fas fa-cog"></i> Support Setting & Offers
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/playlist?list=PLGPpgDt6rdY99nCCp3eSSMCpYtSS7ZiwE"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ display: "flex", alignItems: "center", gap: "8px" }}
                  >
                    <i className="fab fa-youtube"></i> Trust Youtube Channel
                  </a>
                </li>
                <li>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.trustapp"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ display: "flex", alignItems: "center", gap: "8px" }}
                  >
                    <i className="fas fa-download"></i> Download App
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;